import { cateringOrderClient } from '@/services/clients'

export default {
  generateDeliveryQuote(req) {
    return cateringOrderClient.put('/delivery/quote', req, {
      callerHandlesCriticalError: true,
    })
  },
}
